export function openToolMenuTab (tabName, callback = null) {
  const tabButton = document.querySelector(`.tool-menu li > a[tag="${tabName}"]`);
  if (!tabButton) return;

  tabButton.click();
  callback && setTimeout(callback, 150);

  return tabButton;
}
